import { useDeviceType } from '@cian/ui-kit';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { updateChatImages } from '../../actions/chatImages';
import { closeUserCard } from '../../actions/userCard/closeUserCard';
import { UserCardAvatar } from '../../components/UserCard/UserCardAvatar';
import { UserCardLayout } from '../../components/UserCard/UserCardLayout';
import { UserCardMobileLayout } from '../../components/UserCardMobile/UserCardMobileLayout';
import { useCurrentChatCompanionData } from '../../hooks';
import { hostTypeSelector, currentOpenChatSelector, chatImagesSelector } from '../../selectors';
import { userCardIsOpenSelector } from '../../selectors/userCardSelector';
import { EDeviceType } from '../../types/deviceType';
import { EHostType } from '../../types/hostType';
import { UserCardActionsContainer } from '../UserCardActionsContainer';
import { UserCardMobileActionsContainer } from '../UserCardMobileActionsContainer';

export const UserCardContainer = () => {
  const dispatch = useDispatch();

  const currentChat = useSelector(currentOpenChatSelector);
  const hostType = useSelector(hostTypeSelector);
  const isOpen = useSelector(userCardIsOpenSelector);
  const images = useSelector(chatImagesSelector);

  const isIframe = hostType === EHostType.Frame;

  const device = useDeviceType();
  const isMobile = device !== EDeviceType.Desktop;

  const { companionId, companionName, accountTypeName, imageType, avatarUrl, companionIdStr } =
    useCurrentChatCompanionData(currentChat?.chatId);

  const handleClickClose = () => {
    dispatch(closeUserCard());
  };

  const updateChatFiles = React.useCallback(
    (isFirstLoad?: boolean) => {
      if (!currentChat) {
        return;
      }
      if (images && images.page?.canLoadMore) {
        dispatch(updateChatImages({ chatId: currentChat.chatId, offset: images.files?.length }));
      }

      if (isFirstLoad) {
        dispatch(updateChatImages({ chatId: currentChat.chatId }));
      }
    },
    [currentChat, dispatch, images],
  );

  if (!currentChat || !isOpen || !companionId) {
    return null;
  }

  if (isIframe || isMobile) {
    return (
      <UserCardMobileLayout
        handleClickBack={handleClickClose}
        companionName={companionName}
        companionIdStr={companionIdStr}
        companionTypeName={`${accountTypeName}${currentChat.blocked ? ' (Заблокирован)' : ''}`}
        avatar={<UserCardAvatar src={avatarUrl} type={imageType} />}
        actions={<UserCardMobileActionsContainer />}
        updateChatFiles={updateChatFiles}
        isIframe={isIframe}
      />
    );
  }

  return (
    <UserCardLayout
      handleClickClose={handleClickClose}
      companionName={companionName}
      companionIdStr={companionIdStr}
      companionTypeName={`${accountTypeName}${currentChat.blocked ? ' (Заблокирован)' : ''}`}
      avatar={<UserCardAvatar src={avatarUrl} type={imageType} />}
      actions={<UserCardActionsContainer />}
      updateChatFiles={updateChatFiles}
    />
  );
};
